// @ts-nocheck
import { useRef, useState } from 'react'
import './Styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faTimes, faUpload, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'bootstrap/dist/css/bootstrap.min.css';
import { saveAs } from 'file-saver';
interface Props {
    imgFiles: any
}


const ImagePriner = (props: Props) => {
    const printDocument = () => {
          printRef.current.className = ''
          const input: any = document.getElementById('divToPrint');
          if(window.navigator.platform.toUpperCase() === 'IPHONE' || window.navigator.platform.toUpperCase() === 'IPAD'){
            html2canvas(input)
            .then((canvas) => {
              const imgData: any = canvas.toDataURL('image/png');
              const pdf = new jsPDF({
                  orientation: 'portrait',
                  unit: 'mm',
                  format: [215.9, 279.4],
              })
              pdf.addImage(imgData, 'PNG', 0, 0, 215.9, 279.4);
              pdf.save("My vision board custom cards.pdf");
            });            
          }else{
            html2canvas(input, { scale: 10 })
            .then((canvas) => {
              const imgData: any = canvas.toDataURL('image/png');
              const pdf = new jsPDF({
                  orientation: 'portrait',
                  unit: 'mm',
                  format: [215.9, 279.4],
              })
              pdf.addImage(imgData, 'PNG', 0, 0, 215.9, 279.4);
              pdf.save("My vision board custom cards.pdf");
            });
          }
          printRef.current.className = 'd-none';
      }

    const printRef = useRef<any>();

    return (<div>
        <div>
            {/* <button type="submit" className='buttonPrint'>Print</button> */}

            <button className='buttonPrint' onClick={printDocument}>Print</button>
        </div>

        <div id="divToPrint"
            ref={printRef}
            className='d-none'
            style={{
                backgroundColor: '#fff',
                width: '215.9mm',
                minHeight: '279.4mm',
                paddingTop: '19.7612mm',
                paddingLeft: '14.8082mm',
                paddingBottom: '19.7612mm',
                paddingRight: '14.8082mm',

                // border: '1px solid black',
            }}>
            {
                props.imgFiles.filter((img: File) => img).map((img: any, index: number) => {
                    let width = '2.25in';
                    let height = '4.625in';
                    let bleed = '7.4168mm';
                    return <div key={index}>

                        {/* <img src={img} style={{ width: width, height: height, marginRight: (index + 1) % 3 === 0 ? '7.4168mm' : bleed, marginBottom: bleed, float: 'left' }} /> */}
                        <img src={img} style={{
                            width: width,
                            height: height,
                            float: 'left',
                            marginLeft: (index == 1 || index == 4) ? bleed : 0,
                            marginRight: (index == 1 || index == 4) ? bleed : 0,
                            marginTop: (index > 2) ? '4.9276mm' : 0,
                            // border: '1px solid black',
                            // padding: '3.175mm 3.175mm'
                        }} />
                    </div>
                })
            }
        </div>
    </div>);
}




function App() {

    const [cropperView, setCropperView] = useState<boolean>(true);

    const [isImageSelected, setIsImageSelected] = useState<boolean>(false);

    const [imgCount, setImgCount] = useState(6);

    const [imgFiles, setImgFiles] = useState(new Array(imgCount).fill(null))
    const [rawImgFiles, setRawImgFiles] = useState(new Array(imgCount).fill(null))

    const [activeImageIndex, setActiveImageIndex] = useState<number>(0);
    const [dragActive, setDragActive] = useState(false);

    // const [image, setImage] = useState<any>('https://images.pexels.com/photos/5006465/pexels-photo-5006465.jpeg?auto=compress&cs=tinysrgb&h=444&w=216');
    const [image, setImage] = useState<any>(null);

    // handle drag events
    const handleDrag = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e: any, id: number) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        // console.log(id)// drag drop log
        if (e.dataTransfer.files && e.dataTransfer.files[0] && e.dataTransfer.files[0]) {
            let file = e.dataTransfer.files[0];
            if (file.type == 'image/png' || file.type == 'image/jpg' || file.type == 'image/jpeg') {
                setImage(window.URL.createObjectURL(file))
                let temp = rawImgFiles;
                temp[activeImageIndex] = file;
                setRawImgFiles(temp);
                setIsImageSelected(true);
            }
        }
    };


    const handleUImageChage = (e: any) => {
        e = e || window.event;
        e.preventDefault();

        if (e.target.files && e.target.files[0]) {
            let file = e.target.files[0];
            setImage(window.URL.createObjectURL(file));
            let temp = rawImgFiles;
            temp[activeImageIndex] = file;
            setRawImgFiles(temp);
            setIsImageSelected(!isImageSelected)

        }
    }

    const [, updateState] = useState<any>(null);

    const imgRef = useRef<any>();
    const copRef = useRef<any>();
    const inpRef = useRef<any>();


    const handleOnMouseDown = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setIsMouseDown(true);
    }
    const handleOnMouseUp = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setIsMouseDown(false);
    }

    const [direction, setDirection] = useState<string>('x');
    const [isMouseDown, setIsMouseDown] = useState<boolean>(false);

    const [xMouseMove, setXMouseMove] = useState<number>(-1);
    const [yMouseMove, setYMouseMove] = useState<number>(-1);

    function rotate90(src: any, callback: any) {
        var img = new Image()
        img.src = src
        img.onload = function () {
            var canvas = document.createElement('canvas')
            canvas.width = img.height
            canvas.height = img.width
            canvas.style.position = "absolute"
            var ctx = canvas.getContext("2d")
            ctx?.translate(img.height, img.width / img.height)
            ctx?.rotate(Math.PI / 2)
            ctx?.drawImage(img, 0, 0)
            callback(canvas.toDataURL())
            updateState({});
        }
    }


    const handleOnMouseMove = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (isMouseDown) {
            if (direction === 'x') {
                if (copRef.current.style.left === "") {
                    var croppedImg = document.getElementsByClassName('croppedImg')[0]
                    var originalImg = document.getElementsByClassName('originalImg')[0]
                    var croppedImgComp = window.getComputedStyle(croppedImg, null);
                    var originalImgComp = window.getComputedStyle(originalImg, null);
                    copRef.current.style.left = croppedImgComp.left;
                    imgRef.current.style.left = originalImgComp.left;
                    setXMouseMove(e.clientX);
                } else {
                    // imgRef Backimage 
                    // copRef frontImage
                    // copRef left > crop left
                    var img = document.getElementsByClassName('croppedImg')[0];
                    var cropDiv = document.getElementsByClassName('crop')[0];
                    var imgRect = img.getBoundingClientRect();
                    var cropDivRect = cropDiv.getBoundingClientRect();

                    let left = parseInt(copRef.current.style.left.replace('px', ''));
                    let left1 = parseInt(imgRef.current.style.left.replace('px', ''));
                    if (e.clientX > xMouseMove) {
                        if (imgRect.x + 12 < cropDivRect.x) {
                            copRef.current.style.left = left + 3 + 'px';
                            imgRef.current.style.left = left1 + 3 + 'px';
                        }
                    } else {
                        if (imgRect.x + imgRect.width - 12 > cropDivRect.x + cropDivRect.width) {
                            copRef.current.style.left = left - 3 + 'px';
                            imgRef.current.style.left = left1 - 3 + 'px';
                        }
                    }
                    setXMouseMove(e.clientX);
                }

            } else {
                if (copRef.current.style.top === "") {
                    var croppedImg = document.getElementsByClassName('croppedImg1')[0]
                    var originalImg = document.getElementsByClassName('originalImg1')[0]
                    var croppedImgComp = window.getComputedStyle(croppedImg, null);
                    var originalImgComp = window.getComputedStyle(originalImg, null);
                    copRef.current.style.top = croppedImgComp.top;
                    imgRef.current.style.top = originalImgComp.top;
                    setYMouseMove(e.clientY);
                } else {
                    var img = document.getElementsByClassName('croppedImg1')[0];
                    var cropDiv = document.getElementsByClassName('crop1')[0];
                    var imgRect = img.getBoundingClientRect();
                    var cropDivRect = cropDiv.getBoundingClientRect();

                    let top = parseInt(copRef.current.style.top.replace('px', ''));
                    let top1 = parseInt(imgRef.current.style.top.replace('px', ''));
                    if (e.clientY > yMouseMove) {
                        // console.log(top, top1, e.clientY, yMouseMove, e.clientY > yMouseMove)
                        if (imgRect.y + 12 < cropDivRect.y) {
                            copRef.current.style.top = top + 3 + 'px';
                            imgRef.current.style.top = top1 + 3 + 'px';
                        }
                    } else {
                        if (imgRect.y + imgRect.height - 12 > cropDivRect.y + cropDivRect.height) {
                            copRef.current.style.top = top - 3 + 'px';
                            imgRef.current.style.top = top1 - 3 + 'px';
                        }
                    }
                    setYMouseMove(e.clientY);
                }
            }
        }
    }

    const handleOnMouseMove1 = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        var cropDiv = direction === 'x' ? document.getElementsByClassName('crop')[0] : document.getElementsByClassName('crop1')[0];
        var rect = cropDiv.getBoundingClientRect();
        var halfHeight: number = direction === 'x' ? rect.x + 108 : rect.y + 108;
        var mouseValue = direction === 'x' ? e.clientX : e.clientY;
        // console.log(rect)
        // console.log(mouseValue, halfHeight);
        if (direction === 'x') {
            if (copRef.current.style.left === "") {
                var croppedImg = document.getElementsByClassName('croppedImg')[0]
                var originalImg = document.getElementsByClassName('originalImg')[0]
                var croppedImgComp = window.getComputedStyle(croppedImg, null);
                var originalImgComp = window.getComputedStyle(originalImg, null);
                copRef.current.style.left = croppedImgComp.left;
                imgRef.current.style.left = originalImgComp.left;
                setXMouseMove(e.clientX);
            } else {
                // imgRef Backimage 
                // copRef frontImage
                // copRef left > crop left
                var img = document.getElementsByClassName('croppedImg')[0];
                var cropDiv = document.getElementsByClassName('crop')[0];
                var imgRect = img.getBoundingClientRect();
                var cropDivRect = cropDiv.getBoundingClientRect();

                let left = parseInt(copRef.current.style.left.replace('px', ''));
                let left1 = parseInt(imgRef.current.style.left.replace('px', ''));
                if (halfHeight < mouseValue) {
                    if (imgRect.x + 12 < cropDivRect.x) {
                        copRef.current.style.left = left + 3 + 'px';
                        imgRef.current.style.left = left1 + 3 + 'px';
                    }
                } else {
                    if (imgRect.x + imgRect.width - 12 > cropDivRect.x + cropDivRect.width) {
                        copRef.current.style.left = left - 3 + 'px';
                        imgRef.current.style.left = left1 - 3 + 'px';
                    }
                }
                setXMouseMove(e.clientX);
            }

        } else {
            if (copRef.current.style.top === "") {
                var croppedImg = document.getElementsByClassName('croppedImg1')[0]
                var originalImg = document.getElementsByClassName('originalImg1')[0]
                var croppedImgComp = window.getComputedStyle(croppedImg, null);
                var originalImgComp = window.getComputedStyle(originalImg, null);
                copRef.current.style.top = croppedImgComp.top;
                imgRef.current.style.top = originalImgComp.top;
                setYMouseMove(e.clientY);
            } else {
                var img = document.getElementsByClassName('croppedImg1')[0];
                var cropDiv = document.getElementsByClassName('crop1')[0];
                var imgRect = img.getBoundingClientRect();
                var cropDivRect = cropDiv.getBoundingClientRect();

                let top = parseInt(copRef.current.style.top.replace('px', ''));
                let top1 = parseInt(imgRef.current.style.top.replace('px', ''));
                if (halfHeight < mouseValue) {
                    // console.log(top, top1, e.clientY, yMouseMove, e.clientY > yMouseMove)
                    if (imgRect.y + 12 < cropDivRect.y) {
                        copRef.current.style.top = top + 3 + 'px';
                        imgRef.current.style.top = top1 + 3 + 'px';
                    }
                } else {
                    if (imgRect.y + imgRect.height - 12 > cropDivRect.y + cropDivRect.height) {
                        copRef.current.style.top = top - 3 + 'px';
                        imgRef.current.style.top = top1 - 3 + 'px';
                    }
                }
                setYMouseMove(e.clientY);
            }
        }
    }

    return <div className="App">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="cropperMain">
                        {
                            isImageSelected ?
                                <div className="cropperArea">
                                    {
                                        direction === 'x' ?
                                            <>

                                                <div className='box'>
                                                    <button className='arrow-drag arrow-right' onClick={handleOnMouseMove1}></button>
                                                    <button className='arrow-drag arrow-left' onClick={handleOnMouseMove1}></button>
                                                    <img
                                                        ref={imgRef}
                                                        className='originalImg'
                                                        src={image}
                                                        alt="Donald Duck" />
                                                    <div className="crop" style={{ border: '1px solid black', borderRadius: '10px' }}>
                                                        <img
                                                            ref={copRef}
                                                            onMouseDown={handleOnMouseDown}
                                                            onMouseUp={handleOnMouseUp}
                                                            onMouseMove={handleOnMouseMove}
                                                            onMouseEnter={handleOnMouseUp}
                                                            onMouseLeave={handleOnMouseUp}
                                                            draggable={true}
                                                            onClick={handleOnMouseMove1}
                                                            className='croppedImg'
                                                            src={image}
                                                            alt="Donald Duck"
                                                        />
                                                    </div>
                                                </div>

                                            </>
                                            :
                                            <>

                                                <div className='box1'>
                                                    <button className='arrow-drag arrow-top' onClick={handleOnMouseMove1}></button>
                                                    <button className='arrow-drag arrow-bottom' onClick={handleOnMouseMove1}></button>
                                                    <img
                                                        ref={imgRef}
                                                        className='originalImg1'
                                                        src={image}
                                                        alt="Donald Duck" />
                                                    <div className="crop1" style={{ border: '1px solid black', borderRadius: '10px' }}>
                                                        <img
                                                            ref={copRef}
                                                            onMouseDown={handleOnMouseDown}
                                                            onMouseUp={handleOnMouseUp}
                                                            onMouseMove={handleOnMouseMove}
                                                            onMouseEnter={handleOnMouseUp}
                                                            onMouseLeave={handleOnMouseUp}
                                                            onClick={handleOnMouseMove1}
                                                            draggable={true}
                                                            className='croppedImg1'
                                                            src={image}
                                                            alt="Donald Duck"
                                                        />
                                                    </div>
                                                </div>
                                            </>

                                    }
                                    <div className='cropperButtons'>
                                        <button type="submit" className="buttonSet buttonRed" onClick={() => {
                                            setImage(null);
                                            setIsImageSelected(false);
                                            let temp = imgFiles;
                                            temp[activeImageIndex] = null;
                                            setImgFiles(temp);
                                        }}><FontAwesomeIcon onClick={() => {
                                            setImage(null);
                                            setIsImageSelected(false);
                                        }} icon={faXmarkCircle} /></button>
                                        <div className='cropperRatios'>
                                            <button type="submit"
                                                className={`buttonRatio portrait ${cropperView == true ? 'active' : ''}`}
                                                onClick={() => {
                                                    setDirection('x');
                                                    setCropperView(true);
                                                    imgRef.current.style.top = '';
                                                    copRef.current.style.top = '';
                                                }}
                                            ><FontAwesomeIcon icon={faCheck} /></button>
                                            {/* <button onClick={zoom}>Zoom</button> */}
                                            <button type="submit"
                                                className={`buttonRatio landscape ${cropperView == false ? 'active' : ''}`}
                                                onClick={() => {
                                                    setDirection('y');
                                                    setCropperView(false);
                                                    imgRef.current.style.left = '';
                                                    copRef.current.style.left = '';
                                                }}
                                            ><FontAwesomeIcon icon={faCheck} /></button>
                                        </div>
                                        <button type="submit" className="buttonSet buttonGreen"
                                            onClick={() => {
                                                let c = cropperView == true ? 'crop' : 'crop1';
                                                // let c = 'crop';
                                                const node: any = document.getElementsByClassName(c)[0];
                                                node.style.border = '';
                                                node.style['border-radius'] = '';

                                                html2canvas(node)
                                                    .then((canvas) => {
                                                        var img = canvas.toDataURL();

                                                        let temp = imgFiles;
                                                        if (cropperView === false) {
                                                            rotate90(img, function (res: any) {
                                                                temp[activeImageIndex] = res;
                                                            })
                                                        } else {
                                                            temp[activeImageIndex] = img;
                                                        }

                                                        setImgFiles(temp);
                                                        updateState({});
                                                        if (activeImageIndex < 5) {
                                                            setActiveImageIndex(activeImageIndex + 1);
                                                        }
                                                        setIsImageSelected(false);
                                                        node.style.border = '1px solid black';
                                                        node.style['border-radius'] = '10px';
                                                    })
                                            }}
                                        ><FontAwesomeIcon icon={faCheckCircle} /></button>
                                    </div>
                                </div>
                                :
                                <div className='uploadDiv' onDragEnter={() => { setDragActive(true); }}>
                                    <div className='uploadWrap'
                                        onDragEnter={handleDrag}
                                        onDragLeave={handleDrag}
                                        onDragOver={handleDrag}
                                        onDrop={() => handleDrop("event", activeImageIndex)}
                                    >
                                        <div className='uploadButtonBox'>
                                            <FontAwesomeIcon icon={faUpload} />
                                            <p>Drag &amp; Drop your files here</p>
                                            <p>or</p>
                                            <input className='primary'
                                                accept="image/*"
                                                type={'file'}
                                                ref={inpRef}
                                                hidden={true}
                                                onChange={handleUImageChage} />
                                            <button type='button'
                                                className='button' onClick={() => inpRef.current.click()}
                                            >Browse</button>
                                        </div>
                                    </div>
                                </div>
                        }
                        <div className='rowThumb'>
                            {
                                imgFiles.map((file, i) => {
                                    return <div className='colThumb' key={i}>
                                        {
                                            // for altering the drop button and image view
                                            file === null || file === undefined ?
                                                <div className='divThumb'>
                                                    {/* <input type="file" hidden={true} /> */}
                                                    <span
                                                        onClick={() => {
                                                            setActiveImageIndex(i);
                                                            inpRef.current.click();
                                                        }}
                                                        className='buttonAdd'>+</span>
                                                </div>
                                                :
                                                <div className='divThumb'>
                                                    <button type="button"
                                                        onClick={() => {
                                                            let temp = imgFiles;
                                                            imgFiles[i] = null;
                                                            setImgFiles(temp);
                                                            setActiveImageIndex(i);
                                                        }}
                                                        className='buttonClose'><FontAwesomeIcon icon={faTimes} /></button>
                                                    <img src={imgFiles[i] != null ? imgFiles[i] : ''} onClick={() => {
                                                        setImage(window.URL.createObjectURL(rawImgFiles[i]));
                                                        let temp = imgFiles;
                                                        temp[i] = null;
                                                        setImgFiles(temp);
                                                        setActiveImageIndex(i);
                                                        setIsImageSelected(true);
                                                    }} alt="" />
                                                </div>
                                        }
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    <ImagePriner imgFiles={imgFiles} />
                </div>
            </div>
        </div>
    </div >;;

}

export default App

